import { Maybe } from '@karakuri-web/faq-type'

import { value, values } from './maybe'

function joinBreadcrumbUrl(url: string, link: string) {
  const baseUrl = url.replace(/\/$/, '')
  const normalizedLink = link.startsWith('/') ? link : `/${link}`
  const trailingSlashLink =
    normalizedLink === '/' || normalizedLink.endsWith('/') ? normalizedLink : `${normalizedLink}/`

  if (!baseUrl) {
    return trailingSlashLink
  }

  return `${baseUrl}${trailingSlashLink}`
}

function normalizeFaqDate(date?: Maybe<string>) {
  if (!date || date === 'null') {
    return undefined
  }
  return Number.isNaN(new Date(date).getTime()) ? undefined : date
}

function normalizeQuestionUrl(url?: Maybe<string>) {
  if (!url) {
    return undefined
  }

  try {
    const parsedUrl = new URL(url)
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:' ? url : undefined
  } catch (_error) {
    return undefined
  }
}

export function breadcrumb(url: string, links: { title: string; link: string }[]) {
  const itemListElement = links.map(({ title, link }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: title,
    item: joinBreadcrumbUrl(url, link),
  }))
  const breadcrumb = {
    itemListElement,
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
  }
  return breadcrumb
}

export function breadcrumbList(url: string, linksList: { title: string; link: string }[][]) {
  return linksList.map(links => breadcrumb(url, links))
}

export function schemaOrgWebPage(
  siteUrl?: Maybe<string>,
  language?: Maybe<string>,
  defaultDescription?: Maybe<string>,
  defaultTitle?: Maybe<string>,
  buildTime?: string,
  image?: string
) {
  const url = value(siteUrl, '')
  const inLanguage = value(language, '')
  const description = value(defaultDescription, '')
  const name = value(defaultTitle, '')
  return {
    // headline,
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url,
    inLanguage,
    mainEntityOfPage: url,
    description,
    name,
    // author: {
    //   '@type': 'Person',
    //   name: author
    // },
    // copyrightHolder: {
    //   '@type': 'Person',
    //   name: author
    // },
    copyrightYear: '2019',
    // creator: {
    //   '@type': 'Person',
    //   name: author
    // },
    // publisher: {
    //   '@type': 'Person',
    //   name: author
    // },
    // datePublished: '2019-01-18T10:30:00+01:00',
    dateModified: buildTime,
    image: {
      '@type': 'ImageObject',
      url: image,
    },
  }
}

export function faqPage(
  askMaybe?: Maybe<string>,
  contentsMaybe?: Maybe<
    Maybe<{
      text?: Maybe<string>
      contentFormat?: Maybe<string>
      image?: Maybe<string>
    }>[]
  >,
  datePublished?: Maybe<string>,
  dateModified?: Maybe<string>,
  questionUrl?: Maybe<string>
) {
  const ask = value(askMaybe, '')
  const contents = values(contentsMaybe)
  const normalizedDatePublished = normalizeFaqDate(datePublished)
  const normalizedDateModified = normalizeFaqDate(dateModified)
  const normalizedQuestionUrl = normalizeQuestionUrl(questionUrl)
  const result: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: ask,
        acceptedAnswer: {
          '@type': 'Answer',
          text: contents
            ? contents
                .map(c => c && c.text)
                .filter(c => !!c)
                .join('\n')
            : '',
        },
        ...(normalizedQuestionUrl ? { url: normalizedQuestionUrl } : {}),
      },
    ],
  }
  if (normalizedDatePublished) {
    result['datePublished'] = normalizedDatePublished
  }
  if (normalizedDateModified) {
    result['dateModified'] = normalizedDateModified
  }
  return result
}
